
import { ClockIcon } from 'vue-feather-icons';
import CarriersHoraire from '@/pages/cart/components/CarriersHoraire.vue';

import { Button, Popover } from 'element-ui';
import { mapState } from 'vuex';
export default {
  name: 'CheckoutRelayPointCard',
  components: {
    ClockIcon,
    Button,
    Popover,
    CarriersHoraire,
  },
  props: {
    relayPoints: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('checkout', ['checkoutRelayPoint']),

    relayPoint() {
      return this.checkoutRelayPoint;
    },
  },
  methods: {
    chooseAnotherRelayPoint() {
      this.$emit('onChooseAnotherRelayPoint', this.relayPoints[0]);
    },
  },
};
